/**
 * Condition Badge - Displays the condition of a marketplace listing
 */

import { useLanguage } from '../../contexts/LanguageContext';

interface Props {
  condition: 'excellent' | 'good' | 'fair';
  size?: 'sm' | 'md';
}

const CONDITION_COLORS: Record<string, { bg: string; text: string }> = {
  excellent: { bg: 'bg-green-100', text: 'text-green-700' },
  good: { bg: 'bg-blue-100', text: 'text-blue-700' },
  fair: { bg: 'bg-orange-100', text: 'text-orange-700' },
};

export default function ConditionBadge({ condition, size = 'sm' }: Props) {
  const { t } = useLanguage();
  const colors = CONDITION_COLORS[condition] || CONDITION_COLORS.good;

  const CONDITION_LABELS: Record<string, string> = {
    excellent: t('condition.excellent', 'Excellent'),
    good: t('condition.good', 'Good'),
    fair: t('condition.fair', 'Fair'),
  };

  const label = CONDITION_LABELS[condition] || t('condition.unknown', 'Unknown');

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-3 py-1 text-sm';

  return (
    <span className={`inline-flex items-center font-medium rounded-full ${colors.bg} ${colors.text} ${sizeClasses}`}>
      {label}
    </span>
  );
}
